import { AlertController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';
import { log } from 'rxjslog';

import { IAuth } from '../../models/auth';
import { Rfc3339DateProvider } from '../rfc3339date/rfc3339date';
import { apiKey, day, restPath } from '../../app/constants';
import { DomProvider } from '../dom/dom';
import { ComponentsModule } from '../../components/components.module';

export interface ILogin {
  username: string;
  passwd: string;
}

@Injectable()
export class LoginProvider {
  public data$: Observable<IAuth>;
  private login$ = new Observable<ILogin>();
  private authUrl: string;
  private reauthenticateSubject$ = new Subject<void>();

  constructor(
    private alertCtrl: AlertController,
    public http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private rfc3339: Rfc3339DateProvider,
    private dom: DomProvider
  ) {
    let baseUrl = window.location.protocol + '//' + window.location.hostname.replace('oct', 'www') + '/autoflex';
    // if (dom.isLocalhost) {
    //   baseUrl = 'http://localhost:8080';
    // }
    baseUrl += `${restPath}`;
    localStorage.setItem('base_url', baseUrl);
    this.authUrl = `${baseUrl}authenticate?api_key=${apiKey}`;
    this.login$ = this.getLogin$();
    this.data$ = this.auth$();
  }

  public authenticate() {
    this.reauthenticateSubject$.next();
    
  }

  private getLogin$() {
    return this.reauthenticateSubject$.switchMap(() => {
      return Observable.create(async obs => {
        try {
          const login = await this.loginDialog();
          obs.next(login);
        } catch (err) {
          obs.error(err);
        }
      }).retry() as Observable<ILogin>;
    });
  }

  private auth$() {
    const token =
      this.route.snapshot.queryParamMap.get('token') ||
      localStorage.getItem('token');
    const regex = this.router.routerState.snapshot.url.match(/^(.*)\?/);
    if (regex) {
      this.router.navigate([regex[1], '']);
    }

    if (token) {
      const dayLater = new Date(Date.now() + day);
      const tokenValidUntil = this.rfc3339.fromDate(dayLater);
      const ret = {
        token_valid_until: tokenValidUntil,
        token
      };
      return Observable.of(ret);
    } else {
      return this.login$
        .switchMap(({ username, passwd }) => {
          const auth = btoa(`${username}:${passwd}`);
          const headers = { Authorization: `Basic ${auth}` };
          return this.http.get<IAuth>(this.authUrl, { headers });
        })
        .catch(error => {
          setTimeout(() => {
            this.reauthenticateSubject$.next();
          }, 100);
          return Observable.throw(error);
        })
        .retry()
        .shareReplay(1);
    }
  }

  private loginDialog(): Promise<ILogin> {
    return new Promise<ILogin>((resolve, reject) => {
      this.alertCtrl
        .create({
          title: 'Inloggen',
          subTitle: 'Autoflex OCT',
          inputs: [
            {
              name: 'username',
              placeholder: 'Username'
            },
            {
              name: 'passwd',
              placeholder: 'Password',
              type: 'password'
            }
          ],
          buttons: [
            {
              text: 'Annuleren',
              role: 'cancel',
              handler: data => {
                reject(data);
              }
            },
            {
              text: 'Log in',
              handler: data => {
                resolve(data);
              }
            }
          ]
        })
        .present();
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/login/login.ts